/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Credits_ProInputs */

const en_landing_pricing_compare_credits_pro = /** @type {(inputs: Landing_Pricing_Compare_Credits_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100 / month`)
};

const zh_landing_pricing_compare_credits_pro = /** @type {(inputs: Landing_Pricing_Compare_Credits_ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月 100 次`)
};

/**
* | output |
* | --- |
* | "100 / month" |
*
* @param {Landing_Pricing_Compare_Credits_ProInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_credits_pro = /** @type {((inputs?: Landing_Pricing_Compare_Credits_ProInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Credits_ProInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_credits_pro(inputs)
	return zh_landing_pricing_compare_credits_pro(inputs)
});
export { landing_pricing_compare_credits_pro as "landing.pricing.compare_credits_pro" }